<template>
  <div class="consumption">
    <TopTitle title="财务管理" />
    <div class="home-page-tab">
      <el-tabs v-model="tabIndex">
        <el-tab-pane label="消费记录" name="1"></el-tab-pane>
      </el-tabs>
    </div>
    <div style="margin-bottom:16px">
      <el-button type="primary" plain :class="productCode == 'VGM' ? 'active-type-button':''" @click="switchType('VGM')">VGM</el-button>
      <el-button type="primary" plain :class="productCode == 'CPS' ? 'active-type-button':''" @click="switchType('CPS')">预配舱单-上海</el-button>
    </div>
    <!-- 搜索 -->
    <div class="search-box">
      <el-form :inline="true">
        <!-- <el-form-item label="消费产品:">
          <el-select v-model.trim="search.productCode" size="small" placeholder="选择费用类型">
            <el-option v-for="option in productlist" :key="option.code" :value="option.code" :label="option.name"></el-option>
          </el-select>
        </el-form-item> -->
        <!-- <el-form-item label="费用类型:" v-if="productCode == 'VGM'">
          <el-select v-model.trim="search.category" size="small" placeholder="选择费用类型">
            <el-option v-for="option in countryData" :key="option.value" :value="option.value" :label="option.label"></el-option>
          </el-select>
        </el-form-item> -->
        <el-form-item label="费用类型:" v-if="productCode == 'CPS'">
          <el-select v-model.trim="search.type" size="small" placeholder="选择费用类型">
            <el-option v-for="option in cpsCountryData" :key="option.value" :value="option.value" :label="option.label"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="消费时间:">
          <el-date-picker v-model="dateArr" type="daterange" size="small" value-format="yyyy-MM-dd" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期">
          </el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-button size="small" @click="empty">重置</el-button>
          <el-button type="primary" size="small" @click="searchData">查询</el-button>
        </el-form-item>
      </el-form>
    </div>

    <el-link class="export" icon="iconfont icon-daochujilu1" type="primary" @click="exporTables" :underline="false">导出表格</el-link>

    <div class="list-tab-page">
      <div class="list-table global-table">
        <el-table :data="dataSource" v-if="productCode == 'VGM'">
          <el-table-column prop="id" label="订单编号"></el-table-column>
          <el-table-column prop="billNo" label="提单号"></el-table-column>
          <el-table-column prop="totalAmount" label="总金额"></el-table-column>
          <el-table-column prop="discountAmount" label="折扣金额"></el-table-column>
          <el-table-column prop="payAmount" label="消费金额"></el-table-column>
          <el-table-column prop="userPhone" label="消费账号"></el-table-column>
          <el-table-column label="消费时间" width="120">
            <template slot-scope="scope">
              <div v-if="scope.row.sendTime">
                <div>{{moment(scope.row.sendTime).format('YYYY-MM-DD')}}</div>
                <div>{{moment(scope.row.sendTime).format('HH:mm:ss')}}</div>
              </div>
            </template>
          </el-table-column>
        </el-table>
        <el-table :data="dataSource" v-else>
          <el-table-column prop="productCode" label="消费产品">
            <template slot-scope="">
              <div>预配舱单-上海</div>
            </template>
          </el-table-column>
          <el-table-column prop="type" label="费用类型">1
            <template slot-scope="scope">
              <div> {{ setCPSCountryData(scope.row.type) }}</div>
            </template>
          </el-table-column>
          <el-table-column prop="masterBillNo" label="主提单号">
            <template slot-scope="scope">
              <div v-if="scope.row.masterBillNo"> {{ scope.row.masterBillNo }}</div>
            </template>
          </el-table-column>
          <el-table-column prop="houseBillNo" label="分提单号" width="200">
            <template slot-scope="scope">
              <div v-if="scope.row.houseBillNo"> {{ scope.row.houseBillNo }}</div>
            </template>
          </el-table-column>
          <el-table-column prop="shipName" label="船名">
            <template slot-scope="scope">
              <div> {{ scope.row.shipName }}</div>
            </template>
          </el-table-column>
          <el-table-column prop="voyageNo" label="航次">
            <template slot-scope="scope">
              <div> {{ scope.row.voyageNo }}</div>
            </template>
          </el-table-column>
          <el-table-column prop="creatorAccount" label="消费账号"></el-table-column>
          <el-table-column prop="payAmount" label="消费金额"></el-table-column>
          <el-table-column prop="discountAmount" label="优惠金额"></el-table-column>
          <el-table-column prop="gmtCreate" label="消费时间" width="120">
            <template slot-scope="scope">
              <div v-if="scope.row.gmtCreate">
                <div>{{moment(scope.row.gmtCreate).format('YYYY-MM-DD')}}</div>
                <div>{{moment(scope.row.gmtCreate).format('HH:mm:ss')}}</div>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="remark" label="备注"></el-table-column>
        </el-table>
      </div>
      <div class="global-page">
        <el-pagination background @size-change="changePageSize" @current-change="changePage" :page-sizes="[15, 30, 45, 60]" :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper" :current-page="currentPage" :total="total"></el-pagination>
      </div>
    </div>
  </div>
</template>
<script>
import moment from 'moment'
import TopTitle from '@/components/TopTitle'
import { getDistanceMonth, urlEncode } from "@/utils/util"
import { httpAjax,httpAgent} from '@/api/ajax'
import { MODE_CONF } from '@/utils/config'

const countryData = [
  {
    label: '发送',
    value: 'SEND'
  },
  {
    label: '改单',
    value: 'UPDATE'
  },
  {
    label: '删单',
    value: 'DELETE'
  },
  // {
  //   label: '重发',
  //   value: 'RESEND'
  // },
  // {
  //   label: '柜面删单',
  //   value: 'COUNTER-DELETE'
  // }
]
const cpsCountryData = [
  {
    label: '发送',
    value: 'NEW'
  },
  {
    label: '改单',
    value: 'UPDATE'
  },
  {
    label: '删单',
    value: 'DELETE'
  }
]

export default {
  components: {
    TopTitle,
  },
  watch: {
    dateArr (val) {
      this.search.startDate = val ? val[0] + ' 00:00:00' : ''
      this.search.endDate = val ? val[1] + ' 23:59:59' : ''
      this.search['gmtCreate.begin'] = val ? val[0] + ' 00:00:00' : ''
      this.search['gmtCreate.end'] = val ? val[1] + ' 23:59:59' : ''
      this.search['sendTime.begin'] = val ? val[0] + ' 00:00:00' : ''
      this.search['sendTime.end'] = val ? val[1] + ' 23:59:59' : ''
    }
  },
  data () {
    return {
      moment,
      countryData,
      cpsCountryData,
      productlist: [],
      dataSource: [],
      tabIndex: '1',
      dateArr: '',
      currentPage: 1,
      pageSize: 15,
      search: {},
      total: 1,
      productCode:"VGM"
    }
  },
  mounted () {
    this.productCodeList()
    this.getdataList('VGM')
  },
  methods: {
    //导出
    exporTables () {
      if (this.dateArr) {
        let num = getDistanceMonth(this.search.startDate, this.search.endDate)
        if (num >= 3) {
          this.$message({
            message: '最多允许导出3个月的数据，请重新选择日期!',
            type: "error",
          })
        } else {
          let token = localStorage.getItem('userToken')
          let obg = {
            pageNum: this.currentPage,
            pageSize: this.pageSize,
            ...this.search
          }
          let domain = '';
          if (window.location.host.split('.')[0] == 'www') {
            domain = window.location.host.split('.')[1];
          } else {
            domain = window.location.host.split('.')[0];
          }
          if(this.productCode == 'VGM'){
            //window.open(MODE_CONF.base_url + `/services/consum/export?token=${token}${urlEncode(obg)}`)
            window.open(`/agent/website/payOrderListExport?X-company-domain=${domain}&token=${token}${urlEncode(obg)}`)
          }else{
            window.open(`/agent/ccam/export/consum?X-company-domain=${domain}&token=${token}${urlEncode(obg)}`)
          }
        }
      } else {
        this.$message({
          message: '请选择消费时间',
          type: "error",
        })
      }
    },

    setCountryData (code) {
      try {
        let item = this.countryData.filter((n) => n.value == code)
        return item[0].label
      } catch (err) { }
    },
    setCPSCountryData(code){
      try {
        let item = this.cpsCountryData.filter((n) => n.value == code)
        return item[0].label
      } catch (err) { }
    },
    setProductlist (code) {
      try {
        let item = this.productlist.filter((n) => n.code == code)
        return item[0].name
      } catch (err) { }
    },
    productCodeList () {
      this.productlist = [{ "code": "VGM", "name": "VGM" }, { "code": "CPS", "name": "预配舱单-上海" }]
      //, { "code": "AMS", "name": "AMS" }, { "code": "AFR", "name": "AFR" }, { "code": "EM", "name": "EM" }, { "code": "ACI", "name": "ACI" }
      // httpAjax({
      //   url: '/services/consum/productCodeList',
      //   method: "get",
      //   data: {},
      // }).then((response) => {
      //   if (response.success) {
      //     this.productlist = response.data
      //   } else {
      //     this.$message({
      //       message: response.reasonPhrase,
      //       type: 'error'
      //     })
      //   }
      // })
    },
    // 清空
    empty () {
      this.search = {}
      this.dateArr = null
    },
    searchData () {
      this.currentPage = 1
      this.getdataList()
    },
    switchType(type){
      this.currentPage = 1;
      this.getdataList(type);
    },
    getdataList (type) {
      if(type){
        this.productCode = type;
        this.search.productCode = type;
      }
      if(this.productCode == 'VGM'){
        httpAgent({
          url: '/agent/website/payOrderList',
          method: "get",
          data: {
            pageNum: this.currentPage,
            pageSize: this.pageSize,
            ...this.search
          },
        }).then((response) => {
          // console.log(response);
          // if (response.success) {
          //   this.dataSource = response.data
          //   this.currentPage = response.pager.currentPage
          //   this.total = Number(response.pager.total)
          // } else {
          //   this.$message({
          //     message: response.reasonPhrase,
          //     type: 'error'
          //   })
          // }
          this.dataSource = response.records
          this.currentPage = response.pageNum
          this.total = Number(response.total)
        }).catch(()=>{})
      }else{
        httpAgent({
          url: `/agent/ccam/orders/getPayOrderList`,
          method: "get",
          data:{
            pageNum: this.currentPage,
            pageSize: this.pageSize,
            ...this.search
          }
        }).then((response) => {
          console.log(response);
          if (response) {
            this.dataSource = response.records
            this.currentPage = response.pageNum
            this.total = Number(response.total)
          } else {
            this.$message({
              message: '服务器错误',
              type: 'error'
            })
          }
        })
      }
    },
    // 去重
    duplicate (arr) {
      return arr
      var newArr = []
      for (var i = 0; i < arr.length; i++) {
        for (var j = i + 1; j < arr.length; j++) {
          if (arr[i].billNo == arr[j].billNo) {
            ++i
          }
        }
        newArr.push(arr[i])
      }
      return newArr
    },
    changePageSize (num) {
      this.pageSize = num
      this.currentPage = 1
      this.getdataList()
    },
    changePage (page) {
      this.currentPage = page
      this.getdataList()
    }
  }
}
</script>
<style scoped lang="less">
.consumption {
  padding: 0 24px;
  background-color: white;
  height: 100%;
  .nav {
    font-size: 24px;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
    color: #333333;
  }

  .home-page-tab {
    /deep/ .is-active {
      color: #106ae7 !important;
    }
    /deep/ .el-tabs__active-bar {
      background: #106ae7 !important;
    }
    /deep/ .el-tabs__item {
      font-size: 18px;
    }
    /deep/ .el-tabs__item:hover {
      font-size: 18px;
      color: #106ae7 !important;
    }
  }

  .search-box {
    min-height: 56px;
    background: #f7f7fa;
    margin-bottom: 24px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    box-sizing: border-box;
    border-radius: 4px;
    padding: 0 24px;

    .el-form-item {
      margin-bottom: 0;
    }
  }
  .export {
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    cursor: pointer;
    padding-bottom: 16px;
    ::v-deep .iconfont {
      font-size: 12px;
      display: inline-block;
      padding-right: 4px !important;
    }
  }
  .list-tab-page {
    overflow: hidden;
  }
  /deep/.el-form .el-form-item .el-form-item__label {
    line-height: 32px !important;
  }
  .active-type-button {
    background-color: #1170eb !important;
    color: #ffffff !important;
  }
}
.global-page {
  padding-bottom: 24px;
}
</style>